/* @flow */
/*
 *  Copyright 2018 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {ERROR_STATE_MAP} from './ErrorStateConstants';
import './ErrorState.scss';

type Props = {
	errorType: string,
	fromAppController: boolean
};

function getErrorMap(type, fromAppController) {
	let renderErrorObject = {};
	switch (type) {
		case '404':
			return ERROR_STATE_MAP['404'];
		case '500':
			renderErrorObject = {...ERROR_STATE_MAP['500']};
			if (fromAppController) {
				renderErrorObject.title = 'app.errorpage.ccweb.e500.title';
			}
			return renderErrorObject;
		case '504':
			return ERROR_STATE_MAP['504'];
		default:
			return ERROR_STATE_MAP['404'];
	}
}

export default class ErrorState extends Component<Props> {
	render() {
		const errorMap = getErrorMap(this.props.errorType, this.props.fromAppController);
		const appControllerClass = this.props.fromAppController ? ' error-container-new' : '';
		return <div className={`error-container${appControllerClass}`}>
			{this.props.fromAppController ? null : <img src={errorMap.icon} alt='Error' />}
			<div className='error-title'>
				<FormattedMessage id={errorMap.title} />
			</div>
			<div className='error-detail'>
				<FormattedMessage id={errorMap.detail} />
			</div>
		</div>;
	}
};

